<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >

    <div>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Search -->
            <b-col
                cols="12"
                md="3"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchCommand"
                    class="d-inline-block mr-1"
                    placeholder="جستجو بر اساس نام محصول..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start my-1 my-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>

            <b-col
                cols="12"
                md="4"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش بر اساس نوع محصول</label>
              <v-select
                  v-model="type"
                  :options="typeOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="type"
                  class="per-page-selector w-50 d-inline-block mx-50"
              />
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mt-2"
            >
              <b-form-group>
                <b-form-checkbox
                    id="remember-me"
                    v-model="IsSelectedForMainPage"
                    name="checkbox-1"
                >
                  نمایش نظرات منتخب
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="comments"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

          <template #cell(userId)="data">
            <div>{{ data.item.userInfo.name }} {{ data.item.userInfo.familyName }}</div>
            <small class="text-muted">@{{ data.item.userId }}</small>
          </template>

          <!-- Column: createDate -->
          <template #cell(createDate)="data">
             <span>
              {{ data.item.createDate.slice(11, 16) }}
              -
              {{ createJalaliDate(data.item.createDate.slice(0, 10)) }}
            </span>
          </template>

          <!-- Column: reply -->
          <template #cell(reply)="data">
            <div v-b-modal.modal-reply class="text-primary"
                 @click="selectedCommentId = data.item.productCommentId ; selectedCommentProductId = data.item.productId">
              <feather-icon size="20" icon="Edit2Icon"/>
            </div>
          </template>

          <!-- Column: edit -->
          <template #cell(edit)="data">
            <b-link :to="{ name: 'apps-e-commerce-comments-edit', params: { id: data.item.productCommentId } }">
              <feather-icon size="20" icon="EditIcon"/>
            </b-link>
          </template>

          <template #cell(chosen)="data">
            <b-form-checkbox
                :checked="data.item.isSelectedForMainPage === true ? true : false"
                name="check-button"
                @change="switchState(data.item)"
                switch
                inline
            >
            </b-form-checkbox>
          </template>


          <!-- Column: delete -->
          <template #cell(delete)="data">
            <b-link class="text-danger"
                    v-b-modal.modal-delete
                    @click="showModal(data.item.productCommentId)"
            >
              <feather-icon size="20" icon="TrashIcon"/>
            </b-link>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCounts"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteComment(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>

    <b-modal
        id="modal-reply"
        centered
        title="ثبت پاسخ برای دیدگاه کاربر"
        ok-only
        ok-title="ثبت"
        @ok="createNewComment"
    >
      <b-form-group
          label="پاسخ شما :"
          label-for="name-input"
      >
        <b-form-input
            id="name-input"
            v-model="commentMessage"
            required
        />
      </b-form-group>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BLink,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import {
  ProductCommentCreateForAdminRequest,
  ProductCommentDeleteRequest,
  ProductCommentGetAllRequest,
  ProductCommentToggleShowInMainPageRequest
} from "@/libs/Api/Product";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  title: "لیست نظرات محصولات - پنل ادمین نهایی شو",
  name: "ProductComments",
  data() {
    return {
      comments: null,
      showOverlay: false,
      currentPage: 1,
      totalCounts: null,
      IsSelectedForMainPage: false,
      perPage: 10,
      type: '',
      typeOptions: [
        {label: 'همه', value: ''},
        {label: 'دوره', value: 1},
        {label: 'لایو', value: 2},
        {label: 'کتاب‌ها', value: 3},
        {label: 'پادکست', value: 4},
        {label: 'پست آموزشی', value: 5},
        {label: 'پکیج', value: 7},
        {label: 'استوری', value: 9},
      ],
      deleteItem: null,
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'userId', label: 'اطلاعات کاربر'},
        {key: 'product.title', label: 'نام محصول'},
        {key: 'message', label: 'متن'},
        {key: 'createDate', label: 'تاریخ ثبت'},
        {key: 'reply', label: 'پاسخ به دیدگاه'},
        {key: 'chosen', label: 'نظر منتخب'},
        {key: 'edit', label: 'ویرایش'},
        {key: 'delete', label: 'حذف'},
      ],
      commentMessage: '',
      selectedCommentId: null,
      selectedCommentProductId: null,
      searchCommand: '',
    }
  },
  async created() {
    await this.getComments()
  },
  methods: {
    async switchState(item) {
      let _this = this;
      _this.showOverlay = true;

      let productCommentToggleShowInMainPageRequest = new ProductCommentToggleShowInMainPageRequest(_this);
      productCommentToggleShowInMainPageRequest.setParams({ProductCommentId: item.productCommentId})
      await productCommentToggleShowInMainPageRequest.fetch(() => {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        window.location.reload()
      }, (error) => {
        _this.showOverlay = false;
      })
    },
    refreshData() {
      this.getPayments()
    },
    async getComments() {
      let _this = this;
      _this.showOverlay = true;

      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        search: _this.searchCommand,
        type: _this.type,
        IsSelectedForMainPage: _this.IsSelectedForMainPage
      }

      let productCommentGetAllRequest = new ProductCommentGetAllRequest(_this);
      productCommentGetAllRequest.setParams(data);
      await productCommentGetAllRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.comments = [];
        content.productComments.forEach(el => {
          if (el.parentId === 0 || el.parentId === null) {
            _this.comments.push(el);
          }
        })
        _this.totalCounts = content.productCommentsCount;
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    async createNewComment() {
      let _this = this;
      _this.showOverlay = true;

      let data = {
        productId: _this.selectedCommentProductId,
        message: _this.commentMessage,
        parentId: _this.selectedCommentId
      }

      let createBlogCommentRequest = new ProductCommentCreateForAdminRequest(_this);
      createBlogCommentRequest.setParams(data);
      await createBlogCommentRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `پاسخ شما ثبت شد.`,
          },
        })
        _this.commentMessage = '';
        _this.selectedCommentId = null;
        _this.selectedCommentBlogId = null
        _this.getComments();
      }, function () {
        _this.showOverlay = false;
      });
    },
    async deleteComment(param) {
      let _this = this;
      _this.showOverlay = true;

      let productCommentDeleteRequest = new ProductCommentDeleteRequest(_this);
      productCommentDeleteRequest.setId(param);
      await productCommentDeleteRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        _this.getComments()
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getComments();
    },
    currentPage: function (nv, ov) {
      this.getComments();
    },
    searchCommand: function (nv, ov) {
      this.getComments();
    },
    type: function (nv, ov) {
      this.getComments();
    },
    IsSelectedForMainPage(nv, ov) {
      this.getComments();
    },
  },
  components: {
    BFormCheckbox,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BLink,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
